// Logotype логотип для главного экрана
export function Logotype() {
    return (
        <div className="logo-wordmark" aria-label="Буквопад">
            <span className="logo-wordmark__spark-group logo-wordmark__spark-group--left" aria-hidden="true">
                <span className="logo-wordmark__spark logo-wordmark__spark--left-top"/>
                <span className="logo-wordmark__spark logo-wordmark__spark--left-bottom"/>
            </span>
            <span className="logo-wordmark__text">Буквопад</span>
            <span className="logo-wordmark__spark-group logo-wordmark__spark-group--right" aria-hidden="true">
                <span className="logo-wordmark__spark logo-wordmark__spark--right-top"/>
                <span className="logo-wordmark__spark logo-wordmark__spark--right-middle"/>
                <span className="logo-wordmark__spark logo-wordmark__spark--right-bottom"/>
            </span>
        </div>
    );
}
